import { Chip } from '@mui/material';

import VNLiveStatusBadge from '@/components/VNLiveStatusBadge/VNLiveStatusBadge';
import { toSourceBadgeStatus } from '@/services/inputStatus/live-input-status.service';

import { SOURCE_STATUS_CHIP_PROPS } from '../statusChipConfig';

type SourceStatusVariant = 'live' | 'connected' | 'disconnected' | 'error' | 'scheduled' | 'notscheduled';

const STATUS_LABELS: Record<SourceStatusVariant, string> = {
  live: 'LIVE',
  connected: 'Connected',
  disconnected: 'Disconnected',
  error: 'Error',
  scheduled: 'Scheduled',
  notscheduled: 'Not Scheduled',
};

const getStatusVariant = (status?: string | null): SourceStatusVariant | null => {
  const normalized = toSourceBadgeStatus(status) ?? status?.toLowerCase().trim();
  if (!normalized || !(normalized in STATUS_LABELS)) {
    return null;
  }
  return normalized as SourceStatusVariant;
};

type SourceStatusBadgeProps = {
  status?: string | null;
};

const SourceStatusBadge = ({ status }: SourceStatusBadgeProps) => {
  const variant = getStatusVariant(status);

  if (!variant) {
    return <>—</>;
  }

  if (variant === 'live') {
    return <VNLiveStatusBadge />;
  }

  const chipProps = SOURCE_STATUS_CHIP_PROPS[variant] ?? { color: 'default' as const, variant: 'outlined' as const };

  return (
    <Chip
      label={STATUS_LABELS[variant]}
      size="small"
      variant={chipProps.variant ?? 'outlined'}
      color={chipProps.color}
    />
  );
};

export default SourceStatusBadge;
